import axios from "axios";

export default {

    fetchSubscriptions() {
        return axios.get('subscriptions')
            .then(response => {
                return response.data
            })
    },

    fetchGroupSubscriptions() {
        return axios.get('subscriptions?filter[stype]=OnlineTeacher Group&expand=subscriptionCourses,subscriptionCourses.course')
            .then(response => {
                return response.data
            })
    },

    fetchIndividualSubscriptions() {
        return axios.get('subscriptions?filter[stype]=OnlineTeacher Individual&expand=subscriptionCourses,subscriptionCourses.course')
            .then(response => {
                return response.data
            })
    },

    fetchSubscription(id) {
        return axios.get('subscriptions/' + id + '?expand=studyProducts')
            .then(response => {
                return response.data
            })
    },

    removeTimetableRecurrent(timetableId) {
        return axios.post('usersubscription/remove-timetable-recurrent', {timetable_id: timetableId})
            .then(response => {
                return response.data
            })
    },
}
